module.exports = {


    data(){
        return {
            holidays: [],
            colors: {
                holidays: {
                    background: '#495057',
                    border: '#888888',
                    text: '#888888',
                },
                expired: {
                    background: '#dc3545',
                    border: '',
                    text: '#fff',
                },
                comingOnsite: {
                    background: '#007bff',
                    border: '',
                    text: '#fff',
                },
                comingWebinar: {
                    background: '#ad5fff',
                    border: '',
                    text: '#fff',
                },
                noPublished: {
                    background: '#2d2d2d',
                    border: '',
                    text: '#fff',
                },
            }
        }
    },
    
    mounted() {
        this.fetchHolidays().then(() => {
            this.onReady();
        }).catch(error => {
            this.onReady();
        })
    },

    methods: {
    
    
        onReady() {
            var self = this;
            var calendarEl = document.getElementById('schedule-calendar');
        
            this.calendar = new FullCalendar.Calendar(calendarEl, {
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                },
                events: this.fetchSchedules,
                eventClick: (click => {
                    if (click.event.extendedProps.schedule) {
                        this.onEventClick(click.event, click.jsEvent, click.view)
                    }
                }),
            });
        
            this.calendar.render();
            this.calendar.setOption('locale', config.locale);
        },
    
        fetchHolidays() {
            return new Promise((resolve, reject) => {
                fetch(`https://www.googleapis.com/calendar/v3/calendars/en.usa%23holiday%40group.v.calendar.google.com/events?key=${App.config.googleKey}`).then(response => {
                    response.json().then(data => {
                    
                        if(data.hasOwnProperty('error')) reject(data.error);
                    
                        data.items.forEach(item => {
                            this.holidays.push({
                                id: item.id,
                                title: item.summary,
                                start: moment(item.start.date).format(),
                                display: 'block',
                                end: moment(item.end.date).format(),
                                backgroundColor: '#afe2ff',
                                borderColor: '#fff',
                                textColor: '#33596e'
                            })
                        })
                        resolve();
                    }).catch(error => reject(error))
                }).catch(error => reject(error))
            })
        },
    
        fetchSchedules(dates, callback){
            callback([])
        },
    
        onEventClick(event, jsEvent, view) {
            // custimoized by the component
        },

        mapSchedules(schedules) {
            return schedules.map(schedule => {
                return this.parseEvent(schedule)
            });
        },
    
        parseEvent(schedule) {
            return {
                // Time
                id: schedule.id,
                start: moment(schedule.date).format(),
                end: moment(schedule.last_day).format(),
                // Style
                borderColor: this.getBorderColor(schedule),
                backgroundColor: this.getBackgroundColor(schedule),
                textColor: this.getTextcolor(schedule),
                // Data
                title: schedule.course.title,
                display: 'block',
                extendedProps: {
                    schedule: schedule,
                }
            };
        },
        
        getBackgroundColor(schedule) {
            if (schedule.is_past) {
                return this.colors.expired.background
            }
            if (!schedule.is_published) {
                return this.colors.noPublished.background
            }
            if (schedule.course.is_onsite) {
                return this.colors.comingOnsite.background
            }
            return this.colors.comingWebinar.background
        },

        getTextcolor(schedule){
            if (schedule.is_past) {
                return this.colors.expired.text
            }
            if (!schedule.is_published) {
                return this.colors.noPublished.text
            }
            return this.colors.comingOnsite.text;
        },

        getBorderColor(schedule){
            return schedule.is_past ? this.colors.expired.border : this.colors.comingOnsite.border
        }
    }
}